module.exports = __webpack_public_path__ + "img/CN.e9b1713f.svg";